import axios from 'axios';
import { getLtiToken } from '../util';
import { apiGatewayBaseUrlLti } from '../services';

// Lti Instance
const ltiInstance = axios.create({
  baseURL: apiGatewayBaseUrlLti,
});

ltiInstance.interceptors.request.use((config) => {
  const ltiToken = getLtiToken();
  if (!ltiToken) {
    return Promise.reject(new Error('Login again'));
  }
  config.headers = {
    'Content-Type': 'application/json',
    LtiAuthorization: ltiToken,
  };
  return config;
});

ltiInstance.interceptors.response.use(
  (response) => {
    return response.data;
  },
  (error) => {
    // We want to return timeout if there is ERR_NETWORK error code
    // due to timeout or bad connection to inform users to check back if applicable
    if (error.code === 'ERR_NETWORK') {
      error.response = {
        data: {
          timeout: true,
        },
      };
    }
    return Promise.reject(error.response.data);
  },
);

export { ltiInstance };
